import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@material-ui/core'
import { currencySymbols, numberWithCommas } from '../../utils'
import { makeStyles } from '@material-ui/core/styles'
import { CalculatorContext } from '../Context/CalculatorContext'

const useStyles = makeStyles((theme) => ({
    root: {
        marginLeft: theme.spacing(1),
        display: 'inline',
        color: theme.palette.grey[50],
        backgroundColor: theme.palette.primary.main,
        borderRadius: 10,
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        margin: 0
    }
}))

const PriceTag = ({ total }) => {
    const { currency } = useContext(CalculatorContext)
    const classes = useStyles()
    return (
        <Typography variant={'body1'} className={classes.root}>
            <b>
                {`${numberWithCommas(Math.round(total))} ${
                    currencySymbols[currency]
                }`}
            </b>
        </Typography>
    )
}

PriceTag.propTypes = {
    total: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired
}

export default PriceTag
